import { BlogStickyBarConfigurationStoryblok, PostsConfigurationStoryblok, PostStoryblok } from '@/types/types-storyblok';

export const resolveStickybarConfig = (
  component: PostStoryblok,
  postLayout: PostsConfigurationStoryblok,
): BlogStickyBarConfigurationStoryblok | undefined => {
  const globalConfig = postLayout.stickyBar?.at(0);
  const postConfig = component.stickyBar?.at(0);
  if (!globalConfig && !postConfig) {
    return undefined;
  }

  // service prefilled value is derived with the following priorities
  // 1. Use the post config values
  // 2. If the post has a bookingCtaSmall, pick the location and service from there
  // 3. Use the global config values
  if (postConfig) {
    return postConfig;
  }
  let serviceValue: string | undefined;
  const bookingCtaSmall = component.body?.find(blok => blok.component === 'bookingCtaSmall');
  if (bookingCtaSmall) {
    serviceValue = bookingCtaSmall.speciality || bookingCtaSmall.manualSpeciality;
  } else {
    serviceValue = globalConfig?.serviceValue;
  }
  return {
    ...(globalConfig as BlogStickyBarConfigurationStoryblok),
    serviceValue,
  };
};
